import { motion } from "framer-motion";

/**
 * Berke Akdağ — Özel Monogram Logosu
 *  - "B" + ince ekg/leaf vurgusu
 *  - emerald → sky gradient
 *  - 3 variant: full (mark + wordmark), mark, white
 */

const GradDefs = ({ id }) => (
  <defs>
    <linearGradient id={`${id}-grad`} x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stopColor="#10B981" />
      <stop offset="55%" stopColor="#0AB7C5" />
      <stop offset="100%" stopColor="#0EA5E9" />
    </linearGradient>
    <linearGradient id={`${id}-stroke`} x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stopColor="#A7F3D0" />
      <stop offset="100%" stopColor="#BAE6FD" />
    </linearGradient>
  </defs>
);

export const LogoMark = ({ size = 40, animated = true, white = false }) => {
  const id = "lm";
  const fill = white ? "#FFFFFF" : `url(#${id}-grad)`;
  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      initial={animated ? { rotate: -8, opacity: 0, scale: 0.8 } : false}
      animate={animated ? { rotate: 0, opacity: 1, scale: 1 } : false}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      whileHover={animated ? { rotate: 4, scale: 1.05 } : {}}
      aria-label="Berke Akdağ"
    >
      <GradDefs id={id} />
      {/* Rounded square medallion */}
      <rect x="2" y="2" width="60" height="60" rx="14" fill={fill} />
      {/* Inner glow ring */}
      <rect
        x="6"
        y="6"
        width="52"
        height="52"
        rx="11"
        fill="none"
        stroke="rgba(255,255,255,0.18)"
        strokeWidth="1"
      />

      {/* "B" mark (custom geometric) */}
      <path
        d="M19 16 H35 C40.5 16 43.5 19 43.5 23.5 C43.5 27 41.5 29.5 38.5 30.5 C42.5 31.3 45 34 45 38 C45 43 41.5 46 36 46 H19 V16 Z M24 21 V28 H33 C35.5 28 37 26.5 37 24.5 C37 22.5 35.5 21 33 21 H24 Z M24 33 V41 H35 C37.7 41 39.5 39.5 39.5 37 C39.5 34.5 37.7 33 35 33 H24 Z"
        fill={white ? "#0F2D2A" : "#FFFFFF"}
      />

      {/* Tiny ECG pulse */}
      <path
        d="M14 53 L22 53 L25 49 L29 57 L33 50 L37 53 L50 53"
        stroke={white ? "#0F2D2A" : "#FFFFFF"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        opacity="0.75"
      />
      {/* Leaf accent dot */}
      <circle cx="48" cy="16" r="3" fill={white ? "#0F2D2A" : "#FFFFFF"} />
    </motion.svg>
  );
};

export const Logo = ({ variant = "full", size = 40, white = false }) => {
  if (variant === "mark") {
    return <LogoMark size={size} white={white} />;
  }
  return (
    <div className="inline-flex items-center gap-3">
      <LogoMark size={size} white={white} />
      <div className="flex flex-col leading-none">
        <span
          className={`font-heading font-black text-base md:text-lg tracking-tight ${
            white ? "text-white" : "text-[#0F2D2A]"
          }`}
        >
          BERKE AKDAĞ
        </span>
        <span
          className={`text-[9px] md:text-[10px] font-semibold uppercase tracking-[0.32em] mt-1 ${
            white ? "text-white/60" : "text-[#0EA5E9]"
          }`}
        >
          Diyetisyen
        </span>
      </div>
    </div>
  );
};

export default Logo;
